import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Kept only for links shared while Boards was a section of its own.
 *
 * Spec 094 merged Boards into Workflows: a board is what a published workflow
 * looks like once work is moving through it, not a sibling of one, and two
 * sections for one thing was what users could not tell apart. So this address has
 * no page behind it any more — it forwards to the one section, which lists every
 * workflow including the ones that have boards.
 *
 * It forwards rather than 404s, and is not deleted, for the reason the sibling
 * `/boards/{key}` redirect already records: the address is already shared, and two
 * lines are cheaper than a dead link in somebody's chat history (FR-017, FR-018).
 *
 * **An index route, not a layout.** It lives at `boards/index.tsx` rather than
 * `boards.tsx` — the convention `workflows/` and `files/` already follow — because
 * a `boards.tsx` beside a `boards/` directory is a *parent* whose loader runs for
 * its children too. As a layout, this redirect would fire on
 * `/boards/{key}` as well and send a shared board link to the workflow list
 * instead of to that board, silently defeating FR-017 for the very addresses the
 * redirect exists to honour.
 *
 * **Deliberately not "redirect to the first board".** It did that before, so that
 * opening Boards showed work rather than a menu. That reason expires here: the
 * workflows page *is* the list, it holds drafts as well as boards, and skipping
 * past it would hide the very page this feature exists to make findable.
 */
export const Route = createFileRoute('/workspaces/$workspaceId/boards/')({
  loader: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/workflows',
      params: { workspaceId: params.workspaceId },
    });
  },
});
